import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { PlatformAdminData } from './platform-identity.models';
import {
  PLATFORM_IDENTITY_FEATURE_KEY,
  type PlatformIdentityState,
} from './platform-identity.reducer';

export const selectPlatformIdentityState =
  createFeatureSelector<PlatformIdentityState>(PLATFORM_IDENTITY_FEATURE_KEY);

export const selectCurrentAdmin = createSelector(
  selectPlatformIdentityState,
  (state): PlatformAdminData | null => state.admin
);

export const selectIsPlatformAdmin = createSelector(
  selectCurrentAdmin,
  (admin): boolean => !!admin
);

export const selectAdminError = createSelector(
  selectPlatformIdentityState,
  (state): string | null => state.error
);

export const selectAdminName = createSelector(
  selectCurrentAdmin,
  (admin): string => admin?.name || admin?.email || ''
);
